var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourceGuides = function SvgResourceGuides(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 5.25v10.5M12 9h1.5M12 6h1.5M2.25 13.5a.75.75 0 0 1-.75-.75V3a.75.75 0 0 1 .75-.75H6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h3.75a.75.75 0 0 1 .75.75v9.75a.75.75 0 0 1-.75.75h-4.5A2.25 2.25 0 0 0 9 15.75a2.25 2.25 0 0 0-2.25-2.25zM4.5 9H6M4.5 6H6"
  })));
};
export default SvgResourceGuides;